import React, { SyntheticEvent, useState, useEffect, ChangeEvent } from 'react';
import axios from 'axios';
import { NavLink, Link, useNavigate, useParams } from 'react-router-dom';
import Title from '../../../components/Title';
import { User } from '../../../models/user';
import { Office } from '../../../models/office';
import TimePickerSelect from "../../../components/TimePickerSelect";
import { useSelection } from '../../../components/context/SelectionContext';
import { Collect } from '../../../models/collect';
import { useTheme, useMediaQuery, SelectChangeEvent, Divider, CardActions, TextField, Tooltip, Typography, Button, Box, Card, Grid, FormControl, MenuItem, InputLabel, Select, CardContent, FormControlLabel, Switch } from '@mui/material';
import { useDrawer } from '../../../components/context/DrawerContext';
import { stickyListRegionWidth } from '../../../components/layouts/StickyListToolbar';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const CobrosEdit: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  document.title = "Editar Cobro - Mis Rutas";
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { office_id, setOffice_id, collect_id, setCollect_id, user_id, setUser_id } = useSelection();
  const { drawerOpen } = useDrawer();

  const [name, setName] = useState('');
  const [user_first_name, setUser_first_name] = useState('');
  const [user_last_name, setUser_last_name] = useState('');
  const [ingress_date, setIngress_date] = useState('');
  const [office_name, setOffice_name] = useState('');
  const [quote, setQuote] = useState('');
  const [days_insurance, setDays_insurance] = useState('0');
  const [insurance, setInsurance] = useState('0');
  const [cons_insurance, setCons_insurance] = useState('0');
  const [cons_insurance_manual, setCons_insurance_manual] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [offices, setOffices] = useState<Office[]>([]);
  const [collects, setCollects] = useState<Collect[]>([]);
  const [isModified, setIsModified] = useState(false); // Estado para rastrear modificaciones


  const [time_open, setTime_open] = useState("");
  const [time_close, setTime_close] = useState("");
  const [valid_time,] = useState(false);
  const [detail_machine] = useState(false);

  const [validTime, setValidTime] = useState(false);
  const [detailMachine, setDetailMachine] = useState(false);
  const [deletePay, setDeletePay] = useState(true);
  const [deleteLend, setDeleteLend] = useState(true);
  const [enable_quote_client, setEnable_quote_client] = useState(false);

  const [hour1, setHour1] = React.useState("00");
  const [minute1, setMinute1] = React.useState("00");

  const [hour2, setHour2] = React.useState("00");
  const [minute2, setMinute2] = React.useState("00");

  const handleHabilitarHorario = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValidTime(event.target.checked); //Switch Handler
  };
  const handleHabilitarDetalle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetailMachine(event.target.checked);
  };

  useEffect(() => {
    const fetchData = async () => {
      showLoading();
      try {
        const [collectsData] = await Promise.all([
          axios.get(`collects/${id}`)
        ]);
        setCollects(collectsData.data.data);
        await new Promise(resolve => setTimeout(resolve, 1000)); // Esperar 3 segundos
      } catch (error) {
        showAlert('Error fetching data!', 'error');
      } finally {
        hideLoading();
      }
    };
    fetchData();
  }, []);

  const initialState = {
    name,
    user_id,
    office_id,
    quote,
  };

  useEffect(() => {
    const fetchData = async () => {
      showLoading();

      try {
        const [usersResponse, officesResponse, collectsResponse] = await Promise.all([
          axios.get('employeesNoCollect'),
          axios.get('alloffices'),
          axios.get(`collects/${id}`)
        ]);

        const collect = collectsResponse.data.data[0]; // ← Accede correctamente al primer objeto

        const availableUsers = Array.isArray(usersResponse.data.data) ? usersResponse.data.data : [];
        const currentUser = collect?.user;
        const mergedUsers = currentUser
          ? [currentUser, ...availableUsers.filter((user: User) => user.id !== currentUser.id)]
          : availableUsers;

        setUsers(mergedUsers);
        setOffices(officesResponse.data.data);
        setCollects(collectsResponse.data.data); // ← guarda el array correctamente

        setName(collect.name);
        setIngress_date(collect.ingress_date);
        setQuote(collect.quote);
        setDays_insurance(String(collect.days_discount ?? 0));
        setInsurance(String(collect.insurance ?? 0));
        setCons_insurance(String(collect.cons_insurance ?? 0));
        setCons_insurance_manual(Boolean(collect.cons_insurance_manual));
        setValidTime(collect.valid_time);
        setDetailMachine(collect.detail_machine);
        setDeletePay(collect.delete_pay === true);
        setDeleteLend(collect.delete_lend === true);
        setEnable_quote_client(Boolean(Number(collect.enable_quote_client ?? 0)));
        if (collect.time_open) {
          setTime_open(collect.time_open);
          const [h1, m1] = collect.time_open.split(":");
          setHour1(h1);
          setMinute1(m1);
        }

        if (collect.time_close) {
          setTime_close(collect.time_close);
          const [h2, m2] = collect.time_close.split(":");
          setHour2(h2);
          setMinute2(m2);
        }
        if (collect.user) {
          setUser_id(collect.user.id);
          setUser_first_name(collect.user.first_name);
          setUser_last_name(collect.user.last_name);
        }

        if (collect.office) {
          setOffice_id(collect.office.id);
          setOffice_name(collect.office.name);
        }


        await new Promise(resolve => setTimeout(resolve, 1000)); // Esperar 3 segundos
      } catch (error) {
        showAlert('Error fetching data!', 'error');

      } finally {
        hideLoading();
      }
    };

    fetchData();
  }, [id]);

  const handleTextInputChange = (setter: React.Dispatch<React.SetStateAction<any>>, fieldName: keyof typeof initialState) => (event: ChangeEvent<HTMLInputElement>) => {
    setter(event.target.value);
    setIsModified(true);
  };

  const handleSelectChange = (setter: React.Dispatch<React.SetStateAction<any>>, fieldName: keyof typeof initialState) => (event: SelectChangeEvent<unknown>) => {
    setter(event.target.value as string);
    setIsModified(true);
  };

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault(); // Evita el envío del formulario por defecto
    if (!name || !user_id || !office_id || !quote) {
      showAlert('Tiene campos pendientes por diligenciar!', 'warning');
      return;
    }
    const formData = {
      name,
      office_id,
      user_id,
      quote,
      days_insurance,
      insurance,
      cons_insurance,
      cons_insurance_manual,
      ingress_date,
      time_open: validTime ? `${hour1}:${minute1}` : null,
      time_close: validTime ? `${hour2}:${minute2}` : null,
      valid_time: validTime,
      detail_machine: detailMachine,
      delete_pay: deletePay,
      delete_lend: deleteLend,
      enable_quote_client,
    };
    const url = `collects/${id}`;
    try {
      showLoading();
      const response = await axios.put(url, formData);
      showAlert('Se ha realizado el registro exitosamente!', 'success');
      await new Promise(response => setTimeout(response, 1000));
      navigate('/administrar/cobros');
    } catch (error) {
      showAlert('Error fetching data!', 'error');
    } finally {
      hideLoading();
    }
  };


  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Title>Editar Cobro</Title>
      </Box>
      <Card sx={{ mb: { xs: 10, md: 12 } }}>
        {/* <CardHeader title='Multi Column with Form Separator' titleTypographyProps={{ variant: 'h6' }} /> */}
        <Divider sx={{ margin: 0 }} />
        <form onSubmit={submit}>
          <CardContent
            sx={{
              width: (t) => stickyListRegionWidth(t, drawerOpen), maxWidth: '100%', boxSizing: 'border-box', overflowX: 'auto', pb: 3, // o usa valores reales de tu drawer
            }}
          >
             <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Nombre' placeholder='Rufino' value={name} onChange={event => setName(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Cupo' type='number' placeholder='0' value={quote} id="manager" onChange={event => setQuote(event.target.value)} inputProps={{ maxLength: 10, min: 0 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Regla días descuento' type='number' placeholder='0' value={days_insurance} onChange={event => setDays_insurance(event.target.value)} inputProps={{ min: 0 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Valor gasto gestión por base'
                  type='number'
                  placeholder='0'
                  value={insurance}
                  onChange={event => setInsurance(event.target.value)}
                  inputProps={{ min: 0 }}
                  helperText='Ejemplo: si cobra 4 por cada 100, aquí va 4.'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Base de cálculo'
                  type='number'
                  placeholder='0'
                  value={cons_insurance}
                  onChange={event => setCons_insurance(event.target.value)}
                  inputProps={{ min: 0 }}
                  helperText='Ejemplo: si cobra 4 por cada 100, aquí va 100.'
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={enable_quote_client}
                      onChange={(e) => setEnable_quote_client(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Préstamos: usar cupo del cliente (si está apagado, se usa el cupo del cobro)"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={cons_insurance_manual}
                      onChange={(event) => setCons_insurance_manual(event.target.checked)}
                    />
                  }
                  label='Gasto gestión manual'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='form-layouts-separator-select-label'>Seleccionar Empleado</InputLabel>
                  {users && users.length > 0 ? (
                    <Select
                      size='small'
                      value={user_id}
                      label='Usuario'
                      defaultValue=""
                      id='form-layouts-separator-select'
                      labelId='form-layouts-separator-select-label'
                      onChange={event => setUser_id(event.target.value)}
                      required
                    >
                      {users.map((user: User) => {
                        // Agregar un console.log para mostrar el valor de collect.user.id
                        return (
                          <MenuItem key={user.id} value={user.id}>
                            {user.first_name} {user.last_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>

              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='form-layouts-separator-select-label'>Seleccionar Oficina</InputLabel>
                  {offices && offices.length > 0 ? (
                    <Select
                      size='small'
                      value={office_id}
                      label='Oficina'
                      defaultValue=''
                      id='form-layouts-separator-select'
                      labelId='form-layouts-separator-select-label'
                      onChange={event => setOffice_id(event.target.value)}
                      required
                    >
                      {offices.map((office: Office) => {
                        return (
                          <MenuItem key={office.id} value={office.id}>
                            {office.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
          <CardActions sx={{ px: 3, py: 2, bgcolor: 'background.paper' }}>
            <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained'>
              Guardar
            </Button>
            <Link to='/administrar/cobros'>
              <Button size='small' color='secondary' variant='outlined'>
                Cancelar
              </Button>
            </Link>
          </CardActions>
        </form>
      </Card>
    </HeaderResponsive>
  );
};
export default CobrosEdit;
